import { useMemo } from 'react';
import { useDriversQuery } from 'src/hooks/useDrivers.query';
import { usePartnerCompaniesRequest } from 'src/hooks/usePartnerCompanies.request';
import { useTrucksQuery } from 'src/hooks/useTrucks.query';

import { IdOption, todayString } from './courseMasterUtils';

/**
 * 通常車両・通常ドライバー・通常運送会社の選択肢。API（Course#defaults_must_be_valid）は自社・有効・仮でないものだけ受けるので、
 * 今日時点で有効なもの（/api/v3/trucks?on=今日 と drivers）から仮を外す。運送会社はカード配車の車両追加ダイアログと同じ全件取得
 */
export function useCourseOptions() {
  const today = useMemo(() => todayString(), []);
  const trucks = useTrucksQuery(today, { enabled: true });
  const drivers = useDriversQuery(today, { enabled: true });
  const partners = usePartnerCompaniesRequest(0, '', '', true, Number.MAX_SAFE_INTEGER);
  const partnerRows = partners.data?.data;
  return useMemo(
    () => ({
      trucks: (trucks.data ?? []).filter((t) => !t.temporary).map((t): IdOption => ({ id: t.id, label: t.licensePlateValue })),
      drivers: (drivers.data ?? []).filter((d) => !d.temporary && d.isActive !== false).map((d): IdOption => ({ id: d.id, label: d.name })),
      partners: (partnerRows ?? []).map((p): IdOption => ({ id: p.id, label: p.name })),
      isLoading: trucks.isPending || drivers.isPending || partners.isPending,
    }),
    [trucks.data, drivers.data, partnerRows, trucks.isPending, drivers.isPending, partners.isPending],
  );
}
